import { cn } from '@/lib/utils';
import React from 'react';
import { getGradientStyle } from './lib/color-utils';

export interface SchedulePastilleProps
  extends React.HTMLAttributes<HTMLDivElement> {
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'solid' | 'line';
}

export function SchedulePastille({
  color = '#007AFF',
  size = 'md',
  variant = 'solid',
  className,
  ...props
}: SchedulePastilleProps) {
  const sizeClasses = {
    sm: variant === 'line' ? 'w-0.5 h-3' : 'w-2 h-2',
    md: variant === 'line' ? 'w-1 h-4' : 'w-3 h-3',
    lg: variant === 'line' ? 'w-1.5 h-5' : 'w-4 h-4',
  };

  return (
    <div
      className={cn(
        variant !== 'line' ? 'rounded-full' : 'rounded-sm',
        sizeClasses[size],
        className
      )}
      style={getGradientStyle(color, variant)}
      {...props}
    />
  );
}
